namespace Areas.Workflows {
    "use strict";

    const tabItems = Areas.createTabsWithSameController("Workflows",
        ["Created", "InProcess", "InProcessPivot", "Completed", "Template"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function gotoCreate() {
        const dataGrid = Areas.getGrid(getDataGridName());
        const dataId = dataGrid.getSelectedRowKeys()[0];

        if (dataId != null) {
            location.href = `/Workflows/Create/CreateWorkflow/${dataId}`;
        }
        else {
            location.href = "/Workflows/Create/CreateWorkflowNoId";
        }
    }

    export function gotoCopy() {
        const dataGrid = Areas.getGrid(getDataGridName());
        const dataId = dataGrid.getSelectedRowKeys()[0];

        if (dataId != null) {
            Areas.sendRequest(`/Workflows/Create/CopyWorkflow/${dataId}`, null, "GET");
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }


    export function gotoCopyUsingId(workflowId: number) {
        return () => {
            if (workflowId != null) {
                Areas.sendRequest(`/Workflows/Create/CopyWorkflow/${workflowId}`, null, "GET");
            }
            else {
                DevExpress.ui.notify("Missing id, contact IT Support!", "warning", 2000);
            }
        }
   }

    export function gotoEdit() {
        Areas.gotoSelected(getDataGridName(), "/Workflows/Edit/Index/");
    }

    const viewUrl = "/Workflows/View/Index/";

    export function gotoView() {
        Areas.gotoSelected(getDataGridName(), viewUrl);
    }

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

    const reviewUrl = "/Workflows/Action/Index/";

    export function gotoReview() {
        Areas.gotoSelected(getDataGridName(), reviewUrl);
    }

    export function reviewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowDetailId; },
            `<a href= '${reviewUrl}{placeholder}'>Review</a>`);
    }

    function getDataGridName() : string {
        const url = window.location.href;

        if (url.indexOf("Created") > 0)
            return "CreatedWorkflowGrid";
        else if (url.indexOf("InProcess") > 0)
            return "InProcessWorkflowGrid";
        else if (url.indexOf("Completed") > 0)
            return "CompletedWorkflowGrid";
        else if (url.indexOf("Template") > 0)
            return "TemplatesWorkflowGrid";
    }
  
}

